<script>

import Topbar from '@components/newtopbar'
import Footer from '@components/newfooter'

export default {
  components: { Topbar, Footer },
  created: () => {
    document.body.classList.add('authentication-bg')
    document.body.classList.add('authentication-bg-pattern')
  },
}
</script>

<template>
	<div>
		<Topbar />
		<div class="">
			<slot />
		</div>
		<Footer />
	</div>
</template>

<style lang="scss">

	body {
		background-color: white;
	}

	menu,ol,ul {
		list-style: none;
		padding:0;
	}
</style>
